import AbstractRequestTask from '../AbstractRequestTask';
import storage from '../../../components/DeviceStorage/DeviceStorage';
import Launcher from '../../apa/Launcher';
import store from '../../../store';
import { DISABLE_MODAL_RETRIES } from '../../RequestManagerConstants';

class ReminderList extends AbstractRequestTask {
  constructor(event_id = '') {
    super();
    this.event_id = event_id;
  }

  getHeaders() {
    return {};
  }

  getUrl() {
    const http = 'https://';
    const url = Launcher.get('akamai_mfwk');

    return `${http}${url}/services/user/v1/reminder/list`;
  }

  getParams() {
    const params = super.getParams();
    //TODO: revisar si se queda esta version v1 o se queda kla version vieja.
    delete params.HKS;
    delete params.api_version;
    //const { event_id } = this;
    // const user_hash = storage.getItem('user_hash') || '';
    const { user: { lasttouch: { reminder = false } = {} } = {} } = store.getState(); // Destructuring a nested object with default value to avoid typeError
    if (reminder) {
      params.lasttouch = reminder;
    }
    return { ...params/*, event_id/*, user_hash */};
  }

  success(data, b) {
    this.resolve(data);
  }

  isValid(data) {
    if (data.errors || data.status === 1 || data.response === 'error') {
      return false;
    }

    return true;
  }

  getShowErrorModal() {
		return DISABLE_MODAL_RETRIES;
	}

}

export default ReminderList;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/ReminderListTask.js